<template>
    <v-card flat>
        <v-card-actions>
        <div style="width:90%; background-color: rgb(240,240,240)">
            <draggable v-model="selectedVar" group="a">
                <v-chip v-if="selectedVar.length==0">{{'Drag to Add Lines to Plot'|translate}}</v-chip>
                <v-chip close v-for="(j, index) in selectedVar"
                        @input="removeSelection(index)"
                        label
                >
                    {{j.equipment_name}} - {{j.name}}
                </v-chip>

            </draggable>

        </div>
            <v-spacer></v-spacer>
            <v-icon class="ml-2 mr-4 cursor-as-pointer" @click="dialog2=true">fa fa-plus</v-icon>
            <v-icon class="mr-4 cursor-as-pointer" @click="removeChart()">fa fa-trash</v-icon>
            <point-picker-dialog v-model="dialog2" :callback="handlePointSelect"></point-picker-dialog>
        </v-card-actions>
        <v-card-text class="padded-card">

            <data3-chart
                         :layout-overrides="plotConfig['layout-overrides']"
                         :on-only="onOnly"
                         ref="plot"
                         :x-axis="plotConfig['x-axis']"
                         :y-axis="plotConfig['y-axis']"
                         :color-axis="plotConfig['color-axis']"
                         :color-axis-scale="plotConfig['color-axis-scale']"
                         :color-axis-title="plotConfig['color-axis-title']"
                         disable-responsive
                         show-units
                         :data-payload="plotConfig['data-payload']"
                         :series-overrides="plotConfig['series-overrides']"
                         :date-range="dateRange"></data3-chart>

        </v-card-text>
    </v-card>
</template>

<script>
  import draggable from 'vuedraggable'
  import PointPickerDialog from "../PointPickerDialog";
  import Data3Chart from "../Data3Chart";

  export default {
    methods: {
      removeSelection (index) {
        this.selectedVar.splice(index,1)
      },

        handlePointSelect(points){
          this.selectedVar=this.selectedVar.concat(points)
        },
        removeChart(){
            this.$emit('removechart')
        }
    },
    props: {
      onOnly: {type: Boolean, default: false},
      dateRange: {type: Object, default: null}
    },
    name: 'PlotAndSelector',
    components: {
      PointPickerDialog,
        Data3Chart,
      draggable
    },
      computed:{
        plotConfig(){
            return  {
                    'layout-overrides': {
                        title:"",
                        colorway: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf'],
                        xaxis: {
                            title: "Time"
                        },
                        yaxis: {
                            title: ""
                        },
                        zaxis: {
                            title: null
                        },
                        showlegend:true,
                        height:300,
                        hovermode:"x",
                        margin:{
                            l: 50,
                            r: 50,
                            t: 50,
                            pad: 1
                        },
                        legend: {
                            orientation: 'h',
                            y: -0.3
                        },
                    },
                    "x-axis":"timestamp",
                    "y-axis":null,
                    "color-axis":null,
                    "color-axis-scale":null,
                    "color-axis-title":null,
                    'data-payload': this.selectedVar.map(function (selectedVar) {
                        let premap={
                            'filters': {
                                equipment_name: selectedVar.equipment_name,
                                sensor_name: selectedVar.name,
                            },
                            seriesOverrides:{
                                type:'scatter',
                                opacity:1,
                                xbins: {
                                    size: 1
                                }
                            },
                            pipeline:[]
                        }

                        return (premap)
                    }),
                }
        }
      },
    data () {
      return {
        selectedVar: [],
          operators:["+","-","*","/"],
          dialog:false,
          dialog2:false,
          newCalcName:null,
          newCalcForm:null,
          layout:{
              hoverlabel: {
                  namelength: -1
              },
              showlegend:true,
              legend: {
                  orientation: 'h',
                  y:-0.3
              },
          }
      }
    },

  }
</script>

<style scoped>
.padded-card{
    padding: 9px;
}
</style>
